import AddedEvidenceCard from "@/components/evidenceGathering/AddedEvidenceCard";
import { Document } from "@/types/models";

interface AddedEvidenceListProps {
  documents: Document[];
  onRemove: (documentId: string) => void;
  onView: (document: Document) => void;
  removingIds?: Set<string>;
}

const AddedEvidenceList = ({ documents, onRemove, onView, removingIds }: AddedEvidenceListProps) => {
  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground mb-3">Added to project ({documents.length})</h3>
      <div className="space-y-3">
        {documents.map((doc) => (
          <AddedEvidenceCard
            key={doc.id}
            document={doc}
            onRemove={() => onRemove(doc.id)}
            onView={() => onView(doc)}
            isRemoving={removingIds?.has(doc.id) ?? false}
          />
        ))}
      </div>
    </div>
  );
};

export default AddedEvidenceList;
